
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { LoadingProvider } from './context/LoadingContext';
import AppRoutes from './routes/AppRoutes';
import PageTransition from './components/PageTransition/PageTransition';

function App() {
  return (
    <Router>
      <LoadingProvider>
        <AnimatePresence mode="wait">
          <PageTransition>
            <AppRoutes />
          </PageTransition>
        </AnimatePresence>
      </LoadingProvider>
    </Router>
  );
}

export default App;